.companyName {
  display: inline-block;
  margin-bottom: -24px;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.8;
  text-align: center;
}

.pressReleaseRoot {
  @container press-release-root (min-width: 1024px) {
    text-align: left;
  }
}

.screen {
  @media screen and (width >= 1024px) {
    text-align: left;
  }
}
